import { Link } from "react-router-dom";
import "../../styles/post-card.css";

const PostCard = ({ post }) => {
  return (
    <article className="post-card">
      <div className="post-card__meta">
        <span>{post.type}</span>
        <span>{post.date}</span>
      </div>
      <h3 className="post-card__title">
        <Link to={post.href || `/post/${post.slug}`}>{post.title}</Link>
      </h3>
      <p className="post-card__excerpt">{post.excerpt}</p>
    </article>
  );
};

export default PostCard;